import {IoIosArrowForward} from "react-icons/io";
import React, {useEffect, useState} from "react";


const TreeMenuItem = ({list, getData, activeSurveyId, activeCollapse = 'collapse1'}) => {

    const [check, setCheck] = useState(activeCollapse)

    useEffect(() => {

    })

    const changeCheck = (ccc) => {
        setCheck(ccc)
    }

    return (<>
        {list?.map((e, i) =>
            e.children ?
                <div key={e.ID} className="grid grid-cols-5 justify-start overflow-hidden text-[#163578] ">

                    <label className="col-span-3 cursor-pointer  grow px-4 py-3 font-bold text-lg"
                           htmlFor={"collapse" + (i + 1)}>{e.NAME}</label>
                    <input
                        className="col-span-1 peer mx-4 my-3 h-0 w-0 appearance-none rounded border text-slate-800 accent-slate-600 opacity-0"
                        type="checkbox" defaultChecked={check === ("collapse" + (i + 1))}
                        onChange={() => changeCheck("collapse" + (i + 1))}
                        name={"collapse" + (i + 1)} id={"collapse" + (i + 1)}/>
                    <IoIosArrowForward
                        className={"col-span-1 m-auto h-5 w-5 transition-all duration-200 peer-checked:rotate-90"}></IoIosArrowForward>

                    <div
                        className="mx-4 border-s-2 col-span-5 -transparent absolute -translate-y-full scale-75 scale-y-0 ps-12 transition-all duration-0 peer-checked:relative peer-checked:translate-y-0 peer-checked:scale-100 peer-checked:scale-y-100 ">
                        <ul>
                            {e.children?.map(el =>
                                <li onClick={() => getData(el.ID)} key={el.ID}
                                    className={"cursor-pointer"}><span
                                    className={activeSurveyId === el.ID ? "active-list" : ""}>{el.NAME}</span>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
                : ""
        )}
    </>)
}

export default TreeMenuItem;